var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClipsGlyph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M102.756 100.171H19.2546C16.9124 100.171 15 98.2584 15 95.9162V24.2545C15 21.9124 16.9124 20 19.2546 20H102.745C105.087 20 107 21.9124 107 24.2545V95.9055C107.011 97.0336 106.57 98.1079 105.775 98.9137C104.969 99.7195 103.895 100.171 102.756 100.171ZM19.2976 95.8732H102.702V24.2975H19.2976V95.8732Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M51.4218 76.7277C50.9275 76.7277 50.4333 76.6095 49.9713 76.3731C48.9292 75.8359 48.2738 74.7615 48.2738 73.5904V46.5803C48.2738 45.3985 48.9292 44.3349 49.9821 43.7869C51.0242 43.2497 52.2598 43.3357 53.216 44.0126L72.3723 57.5069C73.1996 58.087 73.7046 59.0325 73.7046 60.0532C73.7153 61.0738 73.2211 62.0408 72.3831 62.6317L53.2267 76.1475C52.6895 76.5343 52.0556 76.7277 51.4218 76.7277ZM52.5821 48.8258V71.345L68.5582 60.0854L52.5821 48.8258Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.8797 28.595H25.7227V32.8926H30.8797V28.595Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M43.9653 28.595H38.8082V32.8926H43.9653V28.595Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M57.0407 28.595H51.8836V32.8926H57.0407V28.595Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M70.127 28.595H64.9699V32.8926H70.127V28.595Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M83.202 28.595H78.0449V32.8926H83.202V28.595Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M96.2883 28.595H91.1312V32.8926H96.2883V28.595Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M30.8797 87.2781H25.7227V91.5756H30.8797V87.2781Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M43.9653 87.2781H38.8082V91.5756H43.9653V87.2781Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M57.0407 87.2781H51.8836V91.5756H57.0407V87.2781Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M70.127 87.2781H64.9699V91.5756H70.127V87.2781Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M83.202 87.2781H78.0449V91.5756H83.202V87.2781Z",
    fill: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M96.2883 87.2781H91.1312V91.5756H96.2883V87.2781Z",
    fill: "#CFCFCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipsGlyph);
export default __webpack_public_path__ + "static/media/clips_glyph.21c6d066.svg";
export { ForwardRef as ReactComponent };